<h2 mat-dialog-title>{{ 'PAGES.CHANGE_PHP_VERSION.TITLE' | translate }}</h2>
<mat-dialog-content>
  <mat-card-subtitle class="text-black">
    {{ 'PAGES.CHANGE_PHP_VERSION.INFO' | translate }}
  </mat-card-subtitle>

  <mat-card-subtitle>
    <b>{{ 'PAGES.CHANGE_PHP_VERSION.NEW_PHP_VERSION' | translate }}</b>
  </mat-card-subtitle>
  <glxy-form-field [formGroup]="form">
    <select formControlName="php_version" placeholder="PHP Version" (change)="checkValidation($event)">
      <option value="7">
        7.4.11
        @if (currentPhpVersion === '7') {
          <span>(Current)</span>
        }
      </option>
      <option value="8.1">
        8.1
        @if (currentPhpVersion === '8' || currentPhpVersion === '8.1') {
          <span>(Current)</span>
        }
      </option>
      <option value="8.2">
        8.2
        @if (currentPhpVersion === '8.2') {
          <span>(Current)</span>
        }
      </option>
      <option value="8.3">
        8.3
        @if (currentPhpVersion === '8.3') {
          <span>(Current)</span>
        }
      </option>
    </select>
  </glxy-form-field>
  <mat-card-subtitle>
    {{ 'PAGES.CHANGE_PHP_VERSION.WARN' | translate }}
  </mat-card-subtitle>
  @if (warn) {
    <p class="warn-text">
      {{ warnMessageKey | translate: warnMessageParams }}
    </p>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" mat-stroked-button color="accent" [mat-dialog-close]="false">
    {{ 'PAGES.CHANGE_PHP_VERSION.CANCEL' | translate }}
  </button>
  <button
    type="button"
    mat-raised-button
    color="accent"
    [disabled]="warn || !is_accept"
    (click)="changePhpVersion()"
    id="PHP_Version_Change_dialog_box"
    >
    {{ 'PAGES.CHANGE_PHP_VERSION.ACCEPT' | translate }}
  </button>
</mat-dialog-actions>
